import React from 'react';
import './feedback-styles.css';

export const FeedbackSection = () => {
  return (
    <section className='feedback-section'>
      <div className='feedback-container'>
      
     <div className='feed-container bg-teal'>
     {/* <img src="https://apexa-html-demo.vercel.app/assets/img/project/h3_project_img01.jpg"/> */}
     <div className='feed-text-box '>
     <h2 className='expect-heading text-white feedback-title mb-3'>Your Feedback Matters</h2>
        <p className='feedback-description mb-3 text-white'>
          We want these sessions to be as impactful as possible. Please feel
          free to share your thoughts on topics you’d like to see covered in
          future sessions or any feedback from past events. Together, we can
          create an experience that not only informs but inspires.
        </p>
     <h4>Aligning with <span className='text-warning'>Joy@Work</span></h4>
          <p>
            Our Lunch and Learn series is designed to support{' '}
            <strong className='text-warning'>Joy@Work</strong>, a program dedicated to bringing
            fulfillment, engagement, and innovation into our work environment.
            By investing in your growth and equipping you with the latest tools
            and strategies, we’re ensuring a brighter, more efficient future for
            all of us.
          </p>
          <p className='text-center mb-0'>
            Stay tuned for more updates, and let’s continue to drive excellence,
            innovation, and joy in everything we do!
          </p>
     </div>
       
     </div>

        
      </div>
    </section>
  );
};
